import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Auth({ mode = "login" }) {
  const { login, signup } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      if (mode === "login") await login(email, password);
      else await signup(name, email, password);
      toast.success(mode === "login" ? "Welcome back" : "Welcome to the House");
      nav("/account");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Something went wrong");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[80vh] grid lg:grid-cols-2" data-testid={`${mode}-page`}>
      <div className="hidden lg:block relative">
        <img src="https://images.unsplash.com/photo-1642945680515-faada4c0ca7b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxsYWNlJTIwYnJhJTIwbGluZ2VyaWV8ZW58MHx8fHwxNzgzMDgxMTU2fDA&ixlib=rb-4.1.0&q=85" alt="Iamravishing" className="absolute inset-0 w-full h-full object-cover" />
      </div>
      <div className="flex items-center justify-center p-8 lg:p-16">
        <form onSubmit={submit} className="w-full max-w-md">
          <div className="overline text-[#4A1525] mb-4">{mode === "login" ? "Welcome back" : "Join The House"}</div>
          <h1 className="font-serif text-5xl mb-8">{mode === "login" ? "Sign in" : "Create account"}</h1>

          {mode === "signup" && (
            <div className="mb-6">
              <label className="overline block mb-2">Name</label>
              <input required value={name} onChange={e => setName(e.target.value)} className="w-full border-b border-[#E6DED5] bg-transparent py-3 focus:outline-none focus:border-[#4A1525]" data-testid="input-name" />
            </div>
          )}
          <div className="mb-6">
            <label className="overline block mb-2">Email</label>
            <input type="email" required value={email} onChange={e => setEmail(e.target.value)} className="w-full border-b border-[#E6DED5] bg-transparent py-3 focus:outline-none focus:border-[#4A1525]" data-testid="input-email" />
          </div>
          <div className="mb-8">
            <label className="overline block mb-2">Password</label>
            <input type="password" required value={password} onChange={e => setPassword(e.target.value)} className="w-full border-b border-[#E6DED5] bg-transparent py-3 focus:outline-none focus:border-[#4A1525]" data-testid="input-password" />
          </div>

          <button disabled={busy} type="submit" className="w-full bg-[#4A1525] text-[#FAF8F5] py-4 overline hover:bg-[#360F1B] transition-colors disabled:opacity-50" data-testid={`${mode}-submit`}>
            {busy ? "Please wait..." : (mode === "login" ? "Sign in" : "Create account")}
          </button>

          <div className="mt-8 text-sm text-[#5C5C5C]">
            {mode === "login" ? (
              <>New here? <Link to="/signup" className="text-[#4A1525] underline underline-offset-4" data-testid="switch-signup">Create an account</Link></>
            ) : (
              <>Already a member? <Link to="/login" className="text-[#4A1525] underline underline-offset-4" data-testid="switch-login">Sign in</Link></>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}
